import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const YardInventoryWizardRoute: RouteType = {
  name: "YardInventoryWizard",
  path: "/workflows/yard-inventory",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Yard Inventory",
      component: () => import("./YardInventoryWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./YardInventoryWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for yard inventory
      const yardInventoryItemsStore = rootStore.yardInventoryItemsStore as ServiceStore;
      const yardLocationsStore = rootStore.yardLocationsStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;

      await Promise.all([
        yardInventoryItemsStore?.find(),
        yardLocationsStore?.find(),
        panelStore?.find(),
        productsStore?.find(),
        jobStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for yard inventory:", error);
      return false;
    }
  },
};

export default YardInventoryWizardRoute;